<template>
  <v-layout justify-center row wrap>

    <v-flex class="transparent" text-center white--text xs12>
      <v-alert type="error" pt-2  class="text-center " xs12>
        The Strata Inspection Program is fully subscribed. Questions can be sent to
        <b>stratatitle@jcu.edu.au</b>
      </v-alert>
    </v-flex>

  <v-toolbar class="transparent" dark text elevation="0">
    <v-img
      class="hover"
      @click="gotoHome"
      :src="require('@/assets/logo.svg')"
      aspect-ratio="1"
      max-width="30"
    ></v-img>
    <a
      ><v-toolbar-title @click="gotoHome" class="white--text ml-3">
        SIP</v-toolbar-title
      ></a
    >


    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn text @click="gotoHome"> Home</v-btn>
      <v-btn text @click="gotoAbout"> About</v-btn>
      <v-btn text @click="gotoProcess"> The Process</v-btn>
      <v-btn text @click="gotoResilience"> Resilience</v-btn>
      <v-btn text @click="gotoDamage"> Damage</v-btn>
      <v-btn text @click="gotoLogin"> AP Login</v-btn>
      <v-btn text @click="gotoInspectorLogin"> Inspector Login</v-btn>
      <v-btn text @click="gotoHelp"> FAQ</v-btn>
    </v-toolbar-items>
    <v-menu  >
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon  class="hidden-md-and-up" v-on="on" ></v-app-bar-nav-icon>
      </template>
      <v-list>
        <v-list-item @click="gotoHome">
          Home
        </v-list-item>
        <v-list-item text @click="gotoAbout"> About</v-list-item>
        <v-list-item text @click="gotoProcess"> The Process</v-list-item>
        <v-list-item text @click="gotoResilience"> Resilience</v-list-item>
        <v-list-item text @click="gotoDamage"> Damage</v-list-item>
        <v-list-item text @click="gotoLogin"> AP Login</v-list-item>
        <v-list-item text @click="gotoInspectorLogin">
          Inspector Login</v-list-item
        >
        <v-list-item text @click="gotoHelp"> FAQ</v-list-item>
      </v-list>
    </v-menu>




  </v-toolbar>

  </v-layout>




</template>

<style>
.hover {
  cursor: pointer;
}
</style>

<script>
import { router } from "../router";

export default {
  name: "Navbar",
  data: () => ({}),
  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoLogin() {
      router.push("/login");
    },
    gotoHelp() {
      router.push("/faq");
    },
    gotoDamage() {
      router.push("/damage");
    },
    gotoAbout() {
      router.push("/about");
    },
    gotoProcess() {
      router.push("/process");
    },
    gotoResilience() {
      router.push("/resilience");
    },
    gotoInspectorLogin() {
      router.push("/ins-login");
    },
    gotoContact() {
      router.push("/");
    }
  }
};
</script>
